

<template>
    <div class="each-list">
        <div class="left-zone">
            <img :src="item.img"
             @error.once="__change__no__image"
                class="scene-img img-responsive">
        </div>
        <div class="rignt-zone">
            <div class="title-text text-overflow"
                v-text="item.name">

            </div>
            <div class="rate-row">
                <star :score="item.level"
                    shape="laud"></star>
                <div class="ave-price">￥{{item.price}}/人</div>
            </div>
            <div class="tags">
                <div class="tag"
                    v-for="(tag,i) of item.tags"
                    :key="i"
                    v-text="tag"></div>
            </div>
            <div class="address text-overflow"
                v-if="item.address"
                v-text="item.address"></div>
        </div>
    </div>
</template>

<script>
import Star from "@/components/common/Star.vue";
export default {
    name: "ListOfFood",
    // inheritAttrs: false,
    components: { Star },
    props: {
        item: Object
    },
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {}
};
</script>


<style scoped lang="scss">
.each-list {
    padding: 0.4rem 0;
    border-bottom: 1px solid #ebebeb;
    display: flex;
    justify-content: space-between;
    &:nth-last-child(2){
        border-bottom: 0;
    }
    .left-zone {
        .scene-img {
            border-radius: 5px;
            width: 2.4rem;
            height: 2.4rem;
        }
    }
    .rignt-zone {
        width: 6.7rem;
        .title-text {
            font-weight: bold;
            color: #484848;
            font-size: 16px;
        }
        .rate-row {
            margin-top: 0.12rem;
            display: flex;
            align-items: center;
            .ave-price {
                font-size: 13px;
                color: $grey4;
                margin-left: 0.24rem;
            }
        }
        .tags {
            width: 100%;
            display: flex;
            flex-wrap: nowrap;
            margin-top: 0.16rem;
            margin-bottom: 0.14rem;
            min-height: 0.546667rem;
            .tag {
                padding: 0.05rem 0.14rem;
                color: $blue;
                border: 1px solid $blue;
                background: $white;
                margin-right: 0.133333rem;
                font-size: 0.293333rem;
                border-radius: 0.106667rem;
                flex: 0 0 auto;
            }
        }
        .address {
            color: #808080;
            font-size: 12px;
        }
    }
}
</style>

